module.exports = __webpack_public_path__ + "img/Quotable 3.75acda28.svg";